/**
 * VNU: doc tuy chon "Nhan hien thi khi re chuot" (vnuTooltipLabels).
 * Nhan: object, chuoi JSON object, hoac nhieu dong "gia tri = nhan".
 */
export function parseVnuTooltipLabels(raw: unknown): Record<string, string> {
  if (!raw) return {};
  if (typeof raw === 'object' && !Array.isArray(raw)) {
    return Object.fromEntries(
      Object.entries(raw as Record<string, unknown>).map(([k, v]) => [
        k,
        String(v),
      ]),
    );
  }
  const text = String(raw).trim();
  if (!text) return {};
  if (text.startsWith('{')) {
    try {
      return parseVnuTooltipLabels(JSON.parse(text));
    } catch {
      return {};
    }
  }
  const map: Record<string, string> = {};
  text.split(/\r?\n/).forEach(line => {
    const i = line.indexOf('=');
    if (i > 0) {
      const key = line.slice(0, i).trim();
      const label = line.slice(i + 1).trim();
      if (key && label) map[key] = label;
    }
  });
  return map;
}
